import { Steps } from 'antd'

import { SUBJECT_STATUS_ENUM } from '../../../Types'
import { buildSteps, getCurrentStep } from '../../../util/subject-journey'

export const StepsComponent = ({ phasesData, subjectData }) => {
  const currentStep = getCurrentStep(phasesData, subjectData)
  const items = buildSteps(phasesData, subjectData)

  const subjectStatus = subjectData.status === SUBJECT_STATUS_ENUM.TERMINATED ? 'error' : 'process'

  return (
    <>
      <Steps
        type="dot"
        orientation="vertical"
        status={subjectStatus}
        current={subjectData.status === SUBJECT_STATUS_ENUM.COMPLETED ? currentStep + 1 : currentStep}
        items={items}
      />
    </>
  )
}
